import script from "./AnimatedLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedLink.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedLink.vue?vue&type=style&index=0&id=fdb767be&lang=scss&scoped=true"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb767be"]])

export default __exports__